import React, { useState } from "react";
import { Bell } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useAuth } from "../context/AuthContext";
import { subscribeEmail } from "../lib/subscribe";
import { toast } from "sonner";

export const NotifyMe = ({ slug }) => {
  const { t, lang } = useLang();
  const { user } = useAuth();
  const [email, setEmail] = useState(user?.email || "");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const err = await subscribeEmail(email, lang, slug);
    setBusy(false);
    if (err) return toast.error(t(err));
    setDone(true);
    toast.success(t("notify_thanks"));
  };

  if (done) {
    return <p data-testid="notify-me-done" className="mt-4 text-sm text-[#C49A6C]">{t("notify_thanks")}</p>;
  }
  return (
    <form onSubmit={submit} data-testid="notify-me-form" className="mt-4 border border-[#262421] p-5">
      <p className="flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-[#C49A6C]"><Bell size={14} strokeWidth={1.5} />{t("notify_title")}</p>
      <p className="text-xs text-[#8A857D] mt-2 leading-relaxed">{t("notify_sub")}</p>
      <div className="flex items-stretch gap-2 mt-4">
        <input
          type="text" inputMode="email" autoComplete="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} dir="ltr"
          value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@email.com"
          data-testid="notify-me-email"
          className="flex-1 min-w-0 bg-transparent border border-[#262421] px-3 py-3 text-sm outline-none focus:border-[#C49A6C]"
        />
        <button type="submit" disabled={busy} data-testid="notify-me-submit" className="shrink-0 bg-[#C49A6C] text-[#0B0A08] text-[11px] uppercase tracking-[0.2em] px-5 hover:bg-[#E7CBA9] transition-colors disabled:opacity-50">
          {busy ? "…" : t("notify_btn")}
        </button>
      </div>
    </form>
  );
};
